/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetOrganizationCombo200ResponseSchedulesInner } from './GetOrganizationCombo200ResponseSchedulesInner';
import {
    GetOrganizationCombo200ResponseSchedulesInnerFromJSON,
    GetOrganizationCombo200ResponseSchedulesInnerFromJSONTyped,
    GetOrganizationCombo200ResponseSchedulesInnerToJSON,
    GetOrganizationCombo200ResponseSchedulesInnerToJSONTyped,
} from './GetOrganizationCombo200ResponseSchedulesInner';
import type { GetOrganizationCombo200ResponseCategoriesInner } from './GetOrganizationCombo200ResponseCategoriesInner';
import {
    GetOrganizationCombo200ResponseCategoriesInnerFromJSON,
    GetOrganizationCombo200ResponseCategoriesInnerFromJSONTyped,
    GetOrganizationCombo200ResponseCategoriesInnerToJSON,
    GetOrganizationCombo200ResponseCategoriesInnerToJSONTyped,
} from './GetOrganizationCombo200ResponseCategoriesInner';

/**
 * 
 * @export
 * @interface GetOrganizationCombo200Response
 */
export interface GetOrganizationCombo200Response {
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationCombo200Response
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationCombo200Response
     */
    name: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetOrganizationCombo200Response
     */
    position: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationCombo200Response
     */
    enabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationCombo200Response
     */
    deleted: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationCombo200Response
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationCombo200Response
     */
    color?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationCombo200Response
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationCombo200Response
     */
    imageId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetOrganizationCombo200Response
     */
    price: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationCombo200Response
     */
    hasSchedule: boolean;
    /**
     * 
     * @type {Array<GetOrganizationCombo200ResponseSchedulesInner>}
     * @memberof GetOrganizationCombo200Response
     */
    schedules: Array<GetOrganizationCombo200ResponseSchedulesInner>;
    /**
     * 
     * @type {Array<GetOrganizationCombo200ResponseCategoriesInner>}
     * @memberof GetOrganizationCombo200Response
     */
    categories: Array<GetOrganizationCombo200ResponseCategoriesInner>;
}

/**
 * Check if a given object implements the GetOrganizationCombo200Response interface.
 */
export function instanceOfGetOrganizationCombo200Response(value: object): value is GetOrganizationCombo200Response {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('deleted' in value) || value['deleted'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('hasSchedule' in value) || value['hasSchedule'] === undefined) return false;
    if (!('schedules' in value) || value['schedules'] === undefined) return false;
    if (!('categories' in value) || value['categories'] === undefined) return false;
    return true;
}

export function GetOrganizationCombo200ResponseFromJSON(json: any): GetOrganizationCombo200Response {
    return GetOrganizationCombo200ResponseFromJSONTyped(json, false);
}

export function GetOrganizationCombo200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOrganizationCombo200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'position': json['position'],
        'enabled': json['enabled'],
        'deleted': json['deleted'],
        'organizationId': json['organizationId'],
        'color': json['color'] == null ? undefined : json['color'],
        'description': json['description'] == null ? undefined : json['description'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'price': json['price'],
        'hasSchedule': json['hasSchedule'],
        'schedules': ((json['schedules'] as Array<any>).map(GetOrganizationCombo200ResponseSchedulesInnerFromJSON)),
        'categories': ((json['categories'] as Array<any>).map(GetOrganizationCombo200ResponseCategoriesInnerFromJSON)),
    };
}

export function GetOrganizationCombo200ResponseToJSON(json: any): GetOrganizationCombo200Response {
    return GetOrganizationCombo200ResponseToJSONTyped(json, false);
}

export function GetOrganizationCombo200ResponseToJSONTyped(value?: GetOrganizationCombo200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'position': value['position'],
        'enabled': value['enabled'],
        'deleted': value['deleted'],
        'organizationId': value['organizationId'],
        'color': value['color'],
        'description': value['description'],
        'imageId': value['imageId'],
        'price': value['price'],
        'hasSchedule': value['hasSchedule'],
        'schedules': ((value['schedules'] as Array<any>).map(GetOrganizationCombo200ResponseSchedulesInnerToJSON)),
        'categories': ((value['categories'] as Array<any>).map(GetOrganizationCombo200ResponseCategoriesInnerToJSON)),
    };
}

